import { render, staticRenderFns } from "./FormSlider.vue?vue&type=template&id=bbea768e&"
import script from "./FormSlider.vue?vue&type=script&lang=js&"
export * from "./FormSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports